import { type ReactNode } from 'react';

export interface Announcement {
  id: string;
  enabled: boolean;
  content: ReactNode;
}

export const ANNOUNCEMENTS: readonly Announcement[] = [];
